import { PropsWithChildren } from 'react';
import { tv } from '../../../utils/tv';

const style = tv({
  base: `
    text-paragraphSmall
    text-secondary
  `
});

type Props = PropsWithChildren;

export const FormFieldHelpText = ({ children }: Props) => {
  return <div className={style()}>{children}</div>;
};
